import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { sendHomeContactForm } from '../../controllers/contact';
import { useToast } from '../toast/ToastContext';

function ContactForm() {
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    phone: '',
    parish: '',
    message: ''
  });
  const [sending, setSending] = useState(false);
  const showToast = useToast();

  async function submitContactForm(e) {
    e.preventDefault();
    setSending(true);
    try {
      const response = await sendHomeContactForm(contactForm);
      showToast({
        message: response?.message || 'Mensaje enviado con exito. Gracias por contactarnos.',
        bg: 'success',
        autohide: true,
        delay: 7000,
        title: 'Mensaje enviado'
      });
      setContactForm({
        name: '',
        email: '',
        phone: '',
        parish: '',
        message: ''
      });
    }
    catch (e) {
      showToast({
        message: e?.message || 'No se pudo enviar tu mensaje. Intentalo de nuevo.',
        bg: 'danger',
        autohide: true,
        delay: 8000,
        title: 'Error al enviar mensaje'
      });
    }
    finally {
      setSending(false);
    }
  }

  return (
    <Form className='contact-form mt-4' onSubmit={submitContactForm}>
      <Form.Group className='mb-3 text-start' controlId='contact-name'>
        <Form.Label>Nombre</Form.Label>
        <Form.Control
          type='text'
          required
          maxLength={120}
          value={contactForm.name}
          onChange={e => setContactForm({...contactForm, name: e.target.value})}
        />
      </Form.Group>
      <Form.Group className='mb-3 text-start' controlId='contact-email'>
        <Form.Label>Email</Form.Label>
        <Form.Control
          type='email'
          required
          maxLength={120}
          value={contactForm.email}
          onChange={e => setContactForm({...contactForm, email: e.target.value})}
        />
      </Form.Group>
      <Form.Group className='mb-3 text-start' controlId='contact-phone'>
        <Form.Label>Telefono</Form.Label>
        <Form.Control
          type='text'
          maxLength={60}
          value={contactForm.phone}
          onChange={e => setContactForm({...contactForm, phone: e.target.value})}
        />
      </Form.Group>
      <Form.Group className='mb-3 text-start' controlId='contact-parish'>
        <Form.Label>Parroquia</Form.Label>
        <Form.Control
          type='text'
          maxLength={120}
          value={contactForm.parish}
          onChange={e => setContactForm({...contactForm, parish: e.target.value})}
        />
      </Form.Group>
      <Form.Group className='mb-3 text-start' controlId='contact-message'>
        <Form.Label>Mensaje</Form.Label>
        <Form.Control
          as='textarea'
          rows={4}
          required
          maxLength={2000}
          value={contactForm.message}
          onChange={e => setContactForm({...contactForm, message: e.target.value})}
        />
      </Form.Group>
      <div className='text-start'>
        <Button type='submit' disabled={sending} variant='dark'>
          {sending ? 'Enviando...' : 'Enviar mensaje'}
        </Button>
      </div>
    </Form>
  );
}

export default ContactForm;